export default __webpack_public_path__ + "static/media/Dave.ee6dc4b8.jpg";